import { Link } from 'react-router-dom';
import { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg mb-3 aspect-video">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-foreground-200 whitespace-nowrap">
          {video.duration}
        </div>
        <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500/90 rounded text-xs text-background-50 dark:text-foreground-950 font-medium whitespace-nowrap">
          {video.quality}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-full shadow-lg">
            <i className="ri-play-fill text-background-50 dark:text-foreground-950 text-xl"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500 flex-wrap">
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          {video.rating}
        </span>
        <span>{video.views.toLocaleString()}次</span>
      </div>
    </Link>
  );
}

interface LatestSectionProps {
  videos: VideoItem[];
  categoryName: string;
  categorySlug: string;
  title: string;
}

export default function LatestSection({ videos, categoryName, categorySlug, title }: LatestSectionProps) {
  if (videos.length === 0) return null;

  return (
    <section className="py-10 md:py-14">
      <div className="container-site">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              {title}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">{categoryName}的最新内容</p>
          </div>
          <Link
            to={`/category/${categorySlug}`}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {videos.slice(0, 4).map(video => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}